// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from "lib-core-shared";
export const environment: Environment = {
  name: 'DEV',
  version: '1.2.0.0',
  production: false,
  mockUrl: 'http://localhost:3000',
  apiUrl: 'https://app-api-sngbarratt-productmanagement-dev.azurewebsites.net/api',// 'http://localhost:3000',
  webApiClientId: '2FC6E2AC-18D6-462E-A662-FF6BC75968C9',
  clientId: '27647a53-3a66-493f-bbf7-c0d4bbc08721', 
  cloudInstanceId: 'https://login.microsoftonline.com',
  tennantId: '83ea21c4-c63a-4805-bcb1-302e7df8a817',
  redirectUri: window.location.hostname.includes('localhost') ? 'https://localhost:4200' : 'https://app-web-sngbarratt-productmanagement-dev.azurewebsites.net',
  allowedOriginsForCrossFrameMessaging: [
    window.location.hostname.includes('localhost') ? 'localhost:3000' : 'jcontrol-uk-dev.sngbarratt.com',
    "jcontrol-fr-dev.sngbarratt.com",
    "jcontrol-nl-dev.sngbarratt.com",
    "jcontrol-usa-dev.sngbarratt.com",
  ],
  allowMultipleSupercessions: false,
  branches: [{
    id: 1,
    code: 'SNG',
    name: 'SNG Barratt UK',
    currencyCode: 'GBP',
    defaultCustomerManagerUsername: 'sales.uk@sngbarratt.com'
  }, {
    id: 2,
    code: 'BAU',
    name: 'SNG Barratt US',
    currencyCode: 'USD',
    defaultCustomerManagerUsername: 'sales.usa@sngbarratt.com'

  }, {
    id: 3,
    code: 'SNF',
    name: 'SNG Barratt FR',
    currencyCode: 'EUR',
    defaultCustomerManagerUsername: 'france@sngbarratt.com'
  }, {
    id: 4,
    code: 'SND',
    name: 'SNG Barratt DE',
    currencyCode: 'EUR',
    defaultCustomerManagerUsername: 'sales.nl@sngbarratt.com'
  }, {
    id: 5,
    code: 'SNH',
    name: 'SNG Barratt NL',
    currencyCode: 'EUR',
    defaultCustomerManagerUsername: 'sales.nl@sngbarratt.com'
  },
  {
    id: 6,
    code: 'MOR',
    name: 'Moss Rimmer',
    currencyCode: 'EUR',
    defaultCustomerManagerUsername: 'sales.nl@sngbarratt.com'
  }],
  languages: [{
    id: 1,
    ico: 'EN',
    title: 'English'
  }, {
    id: 2,
    ico: 'FR',
    title: 'French'
  }, {
    id: 3,
    ico: 'DE',
    title: 'German'
  }, {
    id: 4,
    ico: 'NL',
    title: 'Dutch'
  }, {
    id: 5,
    ico: 'US',
    title: 'English(US)'
  }],
  titles: [
    {
      id: 1,
      name: 'Mr'
    },
    {
      id: 2,
      name: 'Miss'
    },
    {
      id: 3,
      name: 'Mrs'
    }
  ],
  rowsPerPage: 10,
  branch: {
    currencySymbol: '£',
    currencyCode: 'GBP',
    branchCode: 'UK',
    branchId: 1,
    address: {
      addressLine1: "The Heritage Building",
      addressLine2: "Stourbridge Road",
      countyState: "Shropshire",
      postalCode: "WV15 6AP",
      townCity: "Bridgnorth",
      countryName: "United Kingdom",
      countryCode: "GB",
    }
  },
  updateRequiredNotice: [
    {
      languageCode: 'EN',
      text: 'Our website has been updated and a reload is required to view this page. Please click OK to continue. \n \nIf this message persists clear your browser storage or contact us.'
    },
    {
      languageCode: 'FR',
      text: 'Notre site a été mis à jour et un rafraichissement de la page est nécessaire. Merci de cliquer sur OK pour continuer. \n \nSi le message persiste, essayez de nettoyer votre historique ou contacter nous.'
    },
    {
      languageCode: 'DE',
      text: 'Our website has been updated and a reload is required to view this page. Please click OK to continue. \n \nIf this message persists clear your browser storage or contact us.'
    },
    {
      languageCode: 'NL',
      text: 'Onze website is bijgewerkt. De webpagina opnieuwladen is vereist om deze pagina te bekijken. Klik op OK om door te gaan.\n \nAls dit bericht aanhoudt, probeer dan uw browseropslag te wissen of neem contact met ons op.'
    },
    {
      languageCode: 'US',
      text: 'Our website has been updated and a reload is required to view this page. Please click OK to continue. \n \nIf this message persists clear your browser storage or contact us.'
    },
  ],
  updateDeclinedNotice: [
    {
      languageCode: 'EN',
      text: 'Without this update some features may not perform optimally.'
    },
    {
      languageCode: 'FR',
      text: 'Sans cette mise à jour, certaines fonctionnalités ne fonctionneront pas de façon optimale.'
    },
    {
      languageCode: 'DE',
      text: 'Without this update some features may not perform optimally.'
    },
    {
      languageCode: 'NL',
      text: 'Zonder deze update werken sommige functies mogelijk niet optimaal.'
    },
    {
      languageCode: 'US',
      text: 'Without this update some features may not perform optimally.'
    },
  ],
  intraGroupPriceMarkUp: 10
}
